import { handleActions } from "redux-actions";

import {
	getDashboardAsyncAction,
	changeUserChartAction,
	changeOnlineTourAction,
	changeOfflineTourAction,
	getSeasonalUniquePlayersAsyncAction,
	resetAction,
} from "./dashboardActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	list: {
		players: 0,
		shops: 0,
		completedTournaments: 0,
		participants: 0,
		uniqueParticipants: 0,
		tournaments: 0,
		playerCountsCreated: [],
		shopCountsApproved: [],
		playerAndShopData: {},
		onlineTournamentData: {},
		offlineTournamentData: {},
	},
	seasonal_unique_player_count: defaultAjaxState,
};

export const dashboardReducer = handleActions(
	new Map([
		[
			getDashboardAsyncAction.success,
			(state, { payload }) => ({
				...state,
				list: payload,
			}),
		],
		[
			changeUserChartAction.success,
			(state, { payload }) => ({
				...state,
				list: {
					...state.list,
					playerAndShopData: payload.playerAndShopData,
				},
			}),
		],
		[
			changeOnlineTourAction.success,
			(state, { payload }) => ({
				...state,
				list: {
					...state.list,
					onlineTournamentData: payload.onlineTournamentData,
				},
			}),
		],
		[
			changeOfflineTourAction.success,
			(state, { payload }) => ({
				...state,
				list: {
					...state.list,
					offlineTournamentData: payload.offlineTournamentData,
				},
			}),
		],

		// get seasonal unique player count
		[
			getSeasonalUniquePlayersAsyncAction.request,
			(state, { payload }) => ({
				...state,
				seasonal_unique_player_count: {
					...initialState.seasonal_unique_player_count,
					loading: true,
				},
			}),
		],
		[
			getSeasonalUniquePlayersAsyncAction.success,
			(state, { payload }) => ({
				...state,
				seasonal_unique_player_count: {
					...initialState.seasonal_unique_player_count,
					response: payload,
				},
			}),
		],
		[
			getSeasonalUniquePlayersAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				seasonal_unique_player_count: {
					...initialState.seasonal_unique_player_count,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
